export default "__VITE_ASSET__CDMy3JwZ__"